"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var globals_1 = require("./globals");
var logger_1 = require("./logger");
var logLevel_1 = require("./logLevel");
var utils_1 = require("./utils");
var DEFAULT_SETTINGS = {
    is_sdk_enabled: 1,
    is_beacon_enabled: 1,
    beacon_freq_sec: 60,
    tracking_url: "",
    retries_no: 3,
    retries_sleep_sec: 10,
    request_timeout_sec: 100,
    session_lifetime_sec: 0,
    api_url: "",
    is_background_tracking_enabled: 0
};
var Settings = /** @class */ (function () {
    function Settings(token) {
        this.results = false;
        this.token = token;
    }
    Settings.getInstance = function (token) {
        if (!Settings.instance && token) {
            Settings.instance = new Settings(token);
        }
        return Settings.instance;
    };
    Settings.prototype.init = function () {
        var _this = this;
        if (!this.results) {
            var origin_1 = "";
            if (typeof window != 'undefined') {
                origin_1 = window.location.origin;
            }
            return fetch(globals_1.default.settings_url + "/" + this.token + ".json", {
                headers: { 'origin': origin_1 }
            })
                .then(function (result) { return result.json(); })
                .then(function (result) {
                _this.data = __assign(__assign({}, DEFAULT_SETTINGS), _this.tryGetSettingsForPlatfrom(result));
                _this.results = true;
                utils_1.default.setSettings(_this.data);
                logger_1.default.getInstance().add("Remote Settings loaded", logLevel_1.default.INFO);
                Promise.resolve(_this.data);
            }).catch(function (e) {
                logger_1.default.getInstance().add("Can not retrieve Settings data from \"" + globals_1.default.settings_url + "/" + _this.token + ".json\". Error says \"" + e + "\"", logLevel_1.default.WARNING);
                var settings = utils_1.default.getSettings();
                if (!settings) {
                    logger_1.default.getInstance().add("Remote Settings loaded from defaults", logLevel_1.default.INFO);
                    _this.data = DEFAULT_SETTINGS;
                    Promise.resolve(_this.data);
                }
                else {
                    logger_1.default.getInstance().add("Remote Settings loaded from local storage", logLevel_1.default.INFO);
                    _this.data = settings;
                    _this.results = true;
                    Promise.resolve(_this.data);
                }
            });
        }
        return Promise.resolve(this.data);
    };
    Settings.prototype.tryGetSettingsForPlatfrom = function (data) {
        var settings = data[globals_1.default.platform];
        if (settings === null || settings === undefined) {
            settings = data["default"];
        }
        return settings;
    };
    Settings.prototype.hasResults = function () {
        return this.results;
    };
    Settings.prototype.get = function (key, defaultValue) {
        return typeof this.data[key] !== "undefined" ? this.data[key] : (typeof defaultValue !== "undefined" ? defaultValue : null);
    };
    Settings.prototype.getApiURL = function () {
        return this.get('api_url', "");
    };
    return Settings;
}());
exports.default = Settings;
//# sourceMappingURL=settings.js.map